// @flow

/**
 * Module dependencies.
 */

import { LinkDefault } from 'client/components/core/buttons/links';
import { List, ListItem } from 'client/components/core/lists';
import { Separator } from 'client/components/separator';
import { Sticky } from 'react-sticky';
import { branch } from 'core/utils';
import { colors, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { getLocalizedUrl, isLocalizedUrlActive } from 'client/core/utils';
import { withRouter } from 'react-router';
import Layout from 'client/components/core/layout';
import React, { Component } from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  fixedStyle: Object | Array<Object>,
  items: Array<Object>,
  location: Object,
  topOffset?: number
};

/**
 * `VerticalSeparator` component.
 */

const VerticalSeparator = styled(Separator.Vertical)`
  bottom: ${units(1)};
  left: ${units(-3)};
  top: auto;
`;

/**
 * Placeholder separator style.
 */

const placeholderSeparatorStyle = `top: -125px;`;

/**
 * `StickySidebar` component.
 */

class StickySidebar extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render links.
   */

  renderLinks(): Array<React$Element<*>> {
    const { items, location } = this.props;

    return items.map(({ key, title }: Object, index: number): React$Element<*> => {
      const isActive = isLocalizedUrlActive(key, location.pathname);

      return (
        <ListItem
          block
          key={key}
        >
          <Layout position={'relative'}>
            {branch(isActive,
              <VerticalSeparator
                absolute
                size={`${(index + 1) * 48}px`}
              />
            )}

            <LinkDefault
              className={branch(isActive, 'active')}
              color={colors.shadesOfBlue.paleSky}
              to={getLocalizedUrl(key)}
            >
              <Text.H4 marginBottom={units(0)}>
                {title}
              </Text.H4>
            </LinkDefault>
          </Layout>
        </ListItem>
      );
    });
  }

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { fixedStyle, topOffset } = this.props;

    return (
      <Sticky topOffset={topOffset}>
        {({ style }) => (
          <div style={{ ...style, ...fixedStyle }}>
            <Layout
              paddingLeft={units(3)}
              position={'relative'}
              whiteSpace={'nowrap'}
            >
              <Separator.Vertical
                absolute
                size={units(17)}
                styles={placeholderSeparatorStyle}
              />

              <List>
                {this.renderLinks()}
              </List>
            </Layout>
          </div>
        )}
      </Sticky>
    );
  }

}

/**
 * Export `StickySidebar` component.
 */

export default compose(
  defaultProps({
    fixedStyle: {},
    topOffset: 0
  }),
  withRouter
)(StickySidebar);



// WEBPACK FOOTER //
// ../src/client/components/legal-and-compliance/sticky-sidebar.js